<template>
  <div class='EnbFrete'>
    <div class="cont-save">
      <button @click="_UpdateFrete(Frete)">Salvar</button>
    </div>
    <div class="select-type">
      <input-select
        :data="tipo"
        text="Tipo"
        :value="Frete.tipo"
        @update:model-value="newValue => setComp(newValue)"
        :cont="{ width: '98%' }"
        :label="{ textAlign: 'left', marginTop: '5px', marginLeft: '3px' }"
        :input="{ width: '100%', padding: '1%', fontSize: '16px', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
    </div>
    <div class="cont">
      <component :is="tipo.filter(t => t.name === Frete.tipo)[0].comp" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputSelect from '@/components/EnbPainel/Produtos/Register/InputSelect'
import TaxaFixa from './TaxaFixa'
import PorKm from './PorKm'
import TabelaBairro from './TabelaBairro'
export default {
  name: 'EnbFrete',
  components: { InputSelect, TaxaFixa, PorKm, TabelaBairro },
  computed: {
    ...mapGetters(['Frete'])
  },
  data () {
    return {
      currentView: '',
      tipo: [
        { name: 'Taxa fixa', comp: 'TaxaFixa' },
        { name: 'Por KM', comp: 'PorKm' },
        { name: 'Tabela Bairro', comp: 'TabelaBairro' }
      ]
    }
  },
  methods: {
    ...mapActions(['changeFrete', '_UpdateFrete', 'GetFrete']),
    setComp (tipo) {
      this.changeFrete({ tipo: tipo })
    }
  },
  created () {
    this.GetFrete()
  }
}
</script>

<style scoped>
.EnbFrete {
  width: 96%;
  height: 96%;
  padding: 2%;
}

.cont-save {
  width: 98%;
  display: flex;
  justify-content: end;
}

button {
  border: 0;
  background-color: #000000;
  color: #FFFFFF;
  border-radius: 5px;
  padding: 1%;
  font-size: 16px;
  cursor: pointer
}

.cont {
  width: 100%;
  height: 77%;
  overflow: auto;
  padding-top: 2%;
}
</style>
